export default __webpack_public_path__ + "static/media/flipflops@3x.bb93b967.png";